/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-restricted-imports
import { DirectorySchemaFragment } from 'api/generated/graphql';
import {
  DirectoryFieldDefinitionData,
  DirectorySchemaData,
} from 'api/types/data/directory/directory';
import { lodash } from 'helpers';

export const parseDirectorySchemaData = (
  data: DirectorySchemaFragment
): DirectorySchemaData => ({
  ...data,
  fieldDefinitions: lodash
    .compact(data.fieldDefinitions)
    .map((fieldDefinition) => {
      let {
        component,
      }: { component: DirectoryFieldDefinitionData['component'] } =
        fieldDefinition;

      if (component === 'Input' && fieldDefinition.validation?.decimal) {
        component = 'Decimal';
      }

      return {
        ...fieldDefinition,
        component,

        validation: {
          ...fieldDefinition.validation,
          date: fieldDefinition.validation?.date
            ? {
                max: fieldDefinition.validation.date.max
                  ? new Date(fieldDefinition.validation.date.max)
                  : undefined,
                min: fieldDefinition.validation.date.min
                  ? new Date(fieldDefinition.validation.date.min)
                  : undefined,
              }
            : undefined,
        },

        selectOptions: fieldDefinition.selectOptions
          ? lodash.compact(fieldDefinition.selectOptions).map((option) => ({
              label:
                option.label.__typename === 'MultiLanguageTextDto'
                  ? {
                      en: option.label.en,
                      ru: option.label.ru,
                    }
                  : option.label.String,
              value:
                option.value.__typename === 'Boolean_container'
                  ? option.value.Boolean
                  : option.value.__typename === 'String_container'
                  ? option.value.String
                  : option.value.__typename === 'Float_container'
                  ? option.value.Float
                  : null,
            }))
          : undefined,
      };
    }),
});
